<template>
    <form class="order">
        <h2 class="sub-title order__title">Состав заказа</h2>
        <div class="order__inner">
            <ul class="order__item-list section-small">
                <li class="order__item order__block" v-if="cart" v-for="item in cart" :key="item.id">
                    <div class="order__item-inner">
                        <p class="order__item-name">{{ item.name }}</p>
                        <img class="order__item-img" v-if="item.id !== 'montage'" :src="item.img"
                             :alt="item.name + 'фото'">
                    </div>
                    <div class="order__item-inner" v-if="item.params && item.params.length">
                        <p class="order__item-name">Параметры</p>
                        <div class="order__item-char">
                            <p class="order__item-char-item" v-for="param in item.params">
                                <span class="order__item-char-item-name">{{ param.name }}:</span>
                                <span>{{ param.value }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="order__item-inner _count">
                        <p class="order__item-name">Количество</p>
                        <div class="order__item-count">
                            <button class="order__item-count-btn" type="button"
                                    @click="decreaseItem(item.id, item.quantity)">-
                            </button>
                            <span class="order__item-count-num">{{ item.quantity }} шт</span>
                            <button class="order__item-count-btn" type="button"
                                    @click="increaseItem(item.id, item.quantity)">+
                            </button>
                        </div>
                    </div>
                    <div class="order__item-inner _price">
                        <p class="order__item-name">Цена</p>
                        <div class="order__item-count">
                            {{ item.sum | format }} руб.
                        </div>
                    </div>
                    <div class="button order__item-remove" type="btn" @click="deleteItem(item.id)">
                        <svg class="icon">
                            <use xlink:href="#trash"></use>
                        </svg>
                    </div>
                </li>
            </ul>
            <div class="order-contacts order__block section-small" id="contactsInfo">
                <h2 class="sub-title">Контактные данные</h2>
                <input-text v-model="order.fio"
                            :v="$v.order.fio"
                            placeholder="ФИО*"
                            errorText="Укажите ФИО"/>
                <input-phone v-model="order.phone"
                             :v="$v.order.phone"
                             errorText="Укажите корректный номер"
                             placeholder="Телефон*"/>
                <input-email v-model="order.email"
                             :v="$v.order.email"
                             errorText="Укажите корректный email"
                             placeholder="Email*"/>
            </div>
            <div class="order-delivery section-small order__block">
                <h2 class="sub-title">Доставка</h2>
                <tabs v-model="order.delivery_type">
                    <tab name="Самовывоз из магазина" :selected="order.delivery_type==='no_delivery'"
                         class="order-delivery__tab-content _first" value="no_delivery">
                        <p class="order-delivery__tab-title">Выберите пункт самовывоза:</p>
                        <ul class="order-delivery__city-list">
                            <li class="order-delivery__city-item radio" v-if="shops" v-for="shop of shops">
                                <input class="radio__input" type="radio" :value="shop.id"
                                       :id="shop.id" name="deliveryShop" v-model="order.delivery.shop_id">
                                <label class="radio__label link" :for="shop.id">
                                    <span>{{ shop.name }} <br> {{ shop.address }}</span>
                                </label>
                            </li>
                        </ul>
                        <contacts-map></contacts-map>
                    </tab>
                    <tab name="Доставка" class="order-delivery__tab-content _second"
                         :selected="order.delivery_type==='delivery'" value="delivery">
                        <p class="order-delivery__tab-title">Укажите адрес:</p>
                        <input-text v-model="order.delivery.street"
                                    :v="$v.order.street"
                                    placeholder="Улица"
                                    errorText="Улица*"/>
                        <input-text v-model="order.delivery.house"
                                    :v="$v.order.house"
                                    placeholder="Дом"
                                    errorText="Дом"/>
                        <input-text v-model="order.delivery.appartament"
                                    :v="$v.order.appartament"
                                    placeholder="Квартира"
                                    errorText="Квартира"/>
                        <customTextarea v-model="order.delivery.comment"
                                        :v="$v.order.comment"
                                        placeholder="Примечание"/>
                        <!--                        <custom-checkbox-->
                        <!--                            ref="montage"-->
                        <!--                            :v="$v.order.mounting"-->
                        <!--                            v-model="order.delivery.mounting"-->
                        <!--                            checkboxName="mountingOrderForm"-->
                        <!--                            checkboxText="требуется монтаж (+450 руб.)"/>-->
                    </tab>
                </tabs>
            </div>
            <div class="order-payment section-small order__block">
                <h2 class="sub-title">Оплата</h2>
                <tabs v-model="order.payment_type">
                    <tab value="card" name="Внести предоплату 70%" :selected="true"></tab>
                    <tab value="cash" name="Предоплата наличными в салоне"></tab>
                    <tab value="credit" name="Рассрочка 0-0-6 от Сбербанк"></tab>
                </tabs>
            </div>
            <div class="order-other order__block">
                <h2 class="sub-title">Дополнительно</h2>
                <custom-checkbox
                    :v="$v.order.measurement"
                    v-model="order.measurement"
                    checkboxName="rulerOrderForm"
                    checkboxText="Бесплатный замер"/>
                <custom-checkbox
                    ref="montage"
                    :v="$v.order.mounting"
                    v-model="order.delivery.mounting"
                    checkboxName="mountingOrderForm"
                    :checkboxText="'требуется монтаж (+'+mount_price+' руб.)'"/>
            </div>
        </div>
        <div class="order-sum">
            <p class="sub-title">Ваш заказ:</p>
            <ul class="order-sum__list">
                <li class="order-sum__item" v-if="cart" v-for="item in cart">
                    <span class="order-sum__item-name"> {{ item.name }}</span>
                    <span class="order-sum__item-price">{{ item.sum | format }} руб.</span>
                </li>
            </ul>
            <p class="order-sum__total sub-title">Итого: {{ this.cart_sum | format }} руб</p>
            <custom-checkbox
                :v="$v.order.politics"
                v-model="order.politics"
                :class="{_error: $v.order.politics.$error}"
                checkboxName="politicsOrderForm"
                checkboxText="Отправляя форму, Вы даёте согласие на обработку персональных данных"/>
            <button class="btn" @click.prevent="orderProducts">Оформить заказ</button>
        </div>
    </form>
</template>

<script>
import inputText from "../common/inputText";
import inputPhone from "../common/inputPhone";
import inputEmail from "../common/inputEmail";
import {email, maxLength, minLength, required, sameAs} from "vuelidate/lib/validators";
import inputFile from "../common/inputFile";
import customCheckbox from "../common/custom-checkbox";
import customTextarea from "../common/customTextarea";
import tabs from './tabs'
import tab from './tab'
import ContactsMap from "../contacts-map";

export default {
    name: 'orderBlock',
    components: {
        ContactsMap, inputEmail, inputText, inputPhone, inputFile,
        Inputmask, customCheckbox, customTextarea, tabs, tab
    },
    methods: {
        orderProducts() {
            this.$v.order.$touch();
            if (this.$v.order.$pending || this.$v.order.$error) {
                let contactsInfo = document.querySelector('#contactsInfo'),
                    contactsInfoTop = contactsInfo.getBoundingClientRect().top + pageYOffset;
                window.scrollTo(0, contactsInfoTop);
            } else {
                let methods = {
                    card: 'order-by-card',
                    cash: 'order',
                    credit: 'order-by-credit'
                }
                this.recaptcha().then(token => {
                    this.order.recaptcha = token;
                    this.$http.post('/api/cart/' + methods[this.order.payment_type], this.order).then(res => {
                        window.location = res.data.url;
                    })
                });
            }
        },
        loadCart() {
            this.$http.get('/api/cart').then((res) => {
                this.cart = res.data.cart;
                this.cart_sum = res.data.cart_sum;
                this.order.delivery.mounting = !!this.cart.find(x => x.id === 'montage');
            })
        },
        increaseItem(id, quantity) {
            if (id === 'montage') {

            } else {
                this.updateItem(id, {quantity: ++quantity});
            }
        },
        decreaseItem(id, quantity) {
            if (id === 'montage') {
                this.$http.get('/api/cart/without-montage').then(res => {
                    this.loadCart();
                });
            } else {
                let q = quantity--;
                if (q === 1) return;
                this.updateItem(id, {quantity: quantity--});
            }
        },
        deleteItem(id) {
            if (id === 'montage') {
                this.$http.get('/api/cart/without-montage').then(res => {
                    this.loadCart();
                });
            } else {
                this.$http.post('/api/cart/product/' + id + '/delete').then(res => {
                    this.loadCart();
                });
            }
        },
        updateItem(id, data) {
            this.$http.post('/api/cart/product/' + id + '/update', data).then(res => {
                this.loadCart();
            });
        }
    },
    created() {
        this.loadCart();
        this.$http.get('/api/shops').then(res => {
            this.shops = res.data;
            Vue.nextTick(() => {
                this.order.delivery.shop_id = this.shops[0].id;
            });
        })
    },
    computed: {
        mount_price: function () {
            if(this.cart && this.cart.length > 1) {
                let sum = 0;
                this.cart.forEach((el) => {
                    sum += el.quantity*el.mount_price;
                })
                return sum;
            }

            return 0;
        }
    },
    watch: {
        'order.delivery.mounting': function (val) {
            if (val) {
                this.$http.get('/api/cart/with-montage').then(res => {
                    this.loadCart();

                });
            } else {
                this.$http.get('/api/cart/without-montage')
                    .then(res => {
                        this.loadCart();
                    });
            }
        },
        lastName: function (val) {
            this.fullName = this.firstName + ' ' + val
        }
    },
    data() {
        return {
            order: {
                fio: null,
                phone: null,
                email: null,
                politics: true,
                measurement: false,
                payment_type: 'card',
                delivery_type: 'no_delivery',
                delivery: {
                    street: null,
                    house: null,
                    appartament: null,
                    comment: null,
                    shop_id: null,
                    mounting: false,
                }
            },
            shops: null,
            cart: null,
            cart_sum: 0
        }
    },
    validations: {
        order: {
            fio: {
                required,
                minLength: minLength(2)
            },
            politics: {
                sameAs: sameAs(() => true)
            },
            email: {
                required,
                email
            },
            street: {},
            house: {},
            appartament: {},
            comment: {},
            mounting: {},
            measurement: {},
            phone: {
                required,
                minLength: minLength(18),
                maxLength: maxLength(18),
                correctAddress(phone) {
                    return /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(phone)
                }
            }
        }
    },
    filters: {
        format: val => `${val}`.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 '),
    },
}
</script>
